import { __assign } from "tslib";
export function mergeThemes(a, b) {
    // Merge impacts perf: we should like to avoid it if it's possible
    if (a && b) {
        return __assign(__assign({}, a), b);
    }
    if (a) {
        return a;
    }
    return b;
}
//# sourceMappingURL=mergeThemes.js.map